import React from 'react';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useSelector } from 'react-redux';
import { isNil } from 'lodash';

function renderSwitch(status, locales) {
  //Υποβολή Αίτησης
  if (status === 'task.name.application_submission')
    return (
      <div className="application-badge start-badge">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_APPLICATION_SUBMISSION)}
        </span>
      </div>
    );
  //Επιστροφή στον Ωφελούμενο
  else if (status === 'task.name.application_returned_to_beneficiary')
    return (
      <div className="application-badge audit-badge">
        <span>Επιστροφή στον Ωφελούμενο</span>
      </div>
    );
  //Προς Αξιολόγηση
  else if (status === 'task.name.application_evaluation')
    return (
      <div className="application-badge audit-badge">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_APPLICATION_EVALUATION)}
        </span>
      </div>
    );
  //Αξιολόγηση από ΦΥ
  else if (status === 'task.name.application_evaluation_by_auditor')
    return (
      <div className="application-badge audit-badge">
        <span>
          {getLocalString(
            locales,
            localNames.TASK_NAME_APPLICATION_EVALUATION_BY_AUDITOR
          )}
        </span>
      </div>
    );
  //Απόρριψη Αξιολόγησης
  else if (status === 'task.name.temporary_rejected')
    return (
      <div className="application-badge reject-badge">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTED)}
        </span>
      </div>
    );
  //Έγκριση Αξιολόγησης
  else if (status === 'task.name.accepted')
    return (
      <div className="application-badge evaluate-badge">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_APPLICATION_ACCEPTED)}
        </span>
      </div>
    );
  //Προς Αξιολόγηση από Επιτροπή
  else if (status === 'task.name.application_evaluation_before_committee')
    return (
      <div className="application-badge audit-badge">
        <span>
          {getLocalString(
            locales,
            localNames.TASK_NAME_APPLICATION_EVALUATION_BEFORE_COMMITTEE
          )}
        </span>
      </div>
    );
  //Αξιολόγησης EE
  else if (status === 'task.name.application_evaluation_by_committee')
    return (
      <div className="application-badge purple">
        <span>
          {getLocalString(
            locales,
            localNames.TASK_NAME_APPLICATION_EVALUATION_BY_COMMITTEE
          )}
        </span>
      </div>
    );
  //Τελικώς Απορριφθείσα
  else if (status === 'task.name.final_rejected')
    return (
      <div className="application-badge reject-badge">
        <span>
          {getLocalString(
            locales,
            localNames.TASK_NAME_APPLICATION_FINAL_REJECTED
          )}
        </span>
      </div>
    );
  //Εκδοση προσωρινής Κατάταξης
  else if (status === 'task.name.issuance_of_provisional_classification')
    return (
      <div className="application-badge purple">
        <span>
          {getLocalString(
            locales,
            localNames.TASK_NAME_ISSUANCE_OF_PROVISIONAL_CLASSIFICATION
          )}
        </span>
      </div>
    );
  //Υποβολή Ένστασης
  else if (status === 'task.name.objection_submission')
    return (
      <div className="application-badge orange">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_OBJECTION_SUBMISSION)}
        </span>
      </div>
    );
  //Αξιολόγηση ΕΕ
  else if (status === 'task.name.objection_evaluation')
    return (
      <div className="application-badge orange">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_OBJECTION_EVALUATION)}
        </span>
      </div>
    );
  //Αξιολόγηση Ενστάσεων - Απόρριψη Ένστασης
  else if (status === 'task.name.application_rejection')
    return (
      <div className="application-badge red">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTION)}
        </span>
      </div>
    );
  //Εκδοση τελικής Κατάταξης
  else if (status === 'task.name.final_classification')
    return (
      <div className="application-badge purple">
        <span>
          {getLocalString(locales, localNames.TASK_NAME_FINAL_CLASSIFICATION)}
        </span>
      </div>
    );
  //ακύρωση Αίτησης
  else if (status === 'task.name.cancel')
    return (
      <div className="application-badge cancel-badge">
        <span>{getLocalString(locales, localNames.TASK_NAME_CANCEL)}</span>
      </div>
    );
  else if (status === 'task.name.program_implementation')
    return (
      <div className="application-badge program-badge">
        <span>
          {getLocalString(
            locales,
            localNames.REQUEST_STATUS_PROGRAMIMPLEMENTATION
          )}
        </span>
      </div>
    );
  else if (status === 'AVAILABLE')
    return (
      <div className="application-badge voucher-available-badge">
        <span>Διαθέσιμο</span>
      </div>
    );
  else if (status === 'RESERVED')
    return (
      <div className="application-badge voucher-reserved-badge">
        <span>Δεσμευμένο</span>
      </div>
    );
  else if (status === 'INITIAL_CHECK_IN_PROGRESS')
    return (
      <div className="application-badge voucher-reserved-badge">
        <span>Υπό αξιολόγηση</span>
      </div>
    );
  else if (status === 'REDEEMED')
    return (
      <div className="application-badge voucher-redeem-badge">
        <span>Εξαργυρωμένο</span>
      </div>
    );
  else if (status === 'PAID')
    return (
      <div className="application-badge voucher-paid-badge">
        <span>Πληρωμένο</span>
      </div>
    );
  else if (status === 'PAYMENT_FAILED')
    return (
      <div className="application-badge reject-badge">
        <span>Αποτυχία Πληρωμής</span>
      </div>
    );
  else if (status === 'CANCELED')
    return (
      <div className="application-badge reject-badge">
        <span>Ακυρωμένο</span>
      </div>
    );
  else if (status === 'PENDING')
    return (
      <div className="application-badge start-badge">
        <span>-</span>
      </div>
    );
  else if (status === 'INITIAL_CHECK_FAIL')
    return (
      <div className="application-badge voucher-redeem-badge">
        <span>Εκκρεμότητα κατόπιν Τυπικού Ελέγχου</span>
      </div>
    );
  else if (status === 'SECONDARY_AUDIT_FAIL')
    return (
      <div className="application-badge voucher-redeem-badge">
        <span>Εκκρεμότητα κατόπιν Ελέγχου ΦΠ</span>
      </div>
    );
  else if (status === 'INITIAL_CHECK_PASS')
    return (
      <div className="application-badge voucher-available-badge">
        <span>Ώριμη προς έλεγχο</span>
      </div>
    );
  else if (status === 'SECONDARY_AUDIT_PASS')
    return (
      <div className="application-badge voucher-available-badge">
        <span>Επιτυχία ελέγχου ΦΠ</span>
      </div>
    );
  else if (status === 'ACCEPTED_INVOICE')
    return (
      <div className="application-badge voucher-approved-blue-badge">
        <span>Εγκρίθηκε βάσει παραστατικού</span>
      </div>
    );
  else if (status === 'APPROVED_WITHOUT_SECONDARY_AUDIT')
    return (
      <div className="application-badge voucher-approved-badge">
        <span>Έγκριση</span>
      </div>
    );
  else return null;
}

const StatusTag = props => {
  const locales = useSelector(state => state.forms?.localeStrings);
  return renderSwitch(props.status, locales);
};

export default StatusTag;
